import * as sessionService from '/@services/system/config-service/session-service';

export function updateNumTimesDisplayNameDialogShown() {
    // Once the user sets thee display name increasing the
    // numTimesDisplayDialogShown to a high number
    const numTimesDialogShown = sessionService.getNumTimesDisplayNameDialogShown();
    if (
        numTimesDialogShown <
        sessionService.getMaxNumTimesDisplayNameDialogShown()
    ) {
        sessionService.setNumTimesDisplayNameDialogShown(
            numTimesDialogShown + 1000,
        );
    }
}

export function shouldShowDisplayNameDialog() {
    return (
        sessionService.isUpdateDisplayNameEnabled() &&
        sessionService.getNumTimesDisplayNameDialogShown() <
            sessionService.getMaxNumTimesDisplayNameDialogShown()
    );
}
